import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled, { keyframes } from 'styled-components';

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  gap: 2rem;
`;

const spinner = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;

export const StyledLoadingSpinner = styled(FontAwesomeIcon)`
  animation: ${spinner} 2s linear infinite;
  font-size: 3rem;
  color: ${({ theme }) => theme.colors.text.lighter};
`;
